import { createSlice } from '@reduxjs/toolkit'
import React from 'react'

const ThemeSlice = createSlice({
    name:'theme',
    initialState:{
        darkMode:sessionStorage.getItem('theme')||'light'
    },
    reducers:{
        changeTheme :(state)=>{
            state.darkMode = state.darkMode == "dark" ? "light" : "dark" ;
        }
    }
});

export const {changeTheme} = ThemeSlice.actions;
export default ThemeSlice.reducer;